 <template>
    <div class="row">
        <div class="col-12 col-xl-12 form-group">
            <label for="fname">{{insuranceType.label}}<span class="star" v-if="insuranceType.is_required">*</span>
            <br><span class="pt-sub-text" v-if="insuranceType.sub_text">{{insuranceType.sub_text}}</span>
            </label>
            <!-- <input-radio-icons :fieldData="insuranceType"></input-radio-icons> -->

                <div class="field-input-radio" v-if="insuranceType.multi_select === false">
                <div class="input-group">
                    <div class="btn-group btn-group-toggle w-100 d-block" data-toggle="buttons">
                    <button v-for="(item, i) in insuranceType.values" type="button" @click.prevent="setProductType(insuranceType.field_value, item.internal_value)" :key="i"
                    v-bind:class="[{'btn py-0 px-0 switch-box-type': true,
                    active: (insuranceType.field_value === item.internal_value), 'first_product-rad': i === 0,}
                    , item.class, item.custome_set]" :id="item.display_value">
                        <div class="text-center each_product">
                          <div v-if="item.icon"
                          class="fas fa-2x d-inline-block"
                          :class="[item.icon]"></div>
                          <div tabindex="-1" class="ins-type-disp mt-1 d-inline-block" :for="insuranceType.field_name + '_radio_option_' + i">{{ item.display_value }}</div>
                        </div>
                        <input
                        type="radio"
                        tabindex="-1"
                        v-model="insuranceType.field_value"
                        :value="item.internal_value"
                        :name="insuranceType.field_name"
                        :id="insuranceType.field_name + '_radio_option_' + i"
                        autocomplete="off">
                    </button>
                    </div>
                </div>
                </div>
                <div class="field-input-radio" v-else>
                <div class="input-group">
                    <div class="btn-group btn-group-toggle w-100 d-block" data-toggle="buttons">
                    <label v-for="(item, i) in insuranceType.values" @click.prevent="setProductType(insuranceType.field_value, item.internal_value)" :key="i"
                    v-bind:class="[{'btn py-1 px-0 switch-box-type each_product': true,
                    active: getMultiSwitchStatus(item, insuranceType),}
                    , item.class, item.custome_set]">
                        <div v-if="item.icon"
                        class="fas fa-2x d-inline-block"
                        :class="[item.icon]"></div>
                        <input
                        type="radio"
                        v-model="insuranceType.field_value"
                        :value="item.internal_value"
                        :name="insuranceType.field_name"
                        :id="insuranceType.field_name + '_radio_option_' + i"
                        autocomplete="off">
                        <div class="ins-type-disp d-inline-block">{{ item.display_value }}</div>
                    </label>
                    </div>
                </div>
                </div>
                <div v-show="errors.has('insurance_type')" class="invalid-feedback d-block">
                    {{ errors.first('insurance_type') }}
                </div>
        </div>
    </div>
</template>
<script>
export default {
  inject: ['$validator'],
  props: ['insuranceType'],
  data() {
    return {
    };
  },
  /* eslint prefer-arrow-callback:  */
  methods: {
    /* Get multiswitch status values */
    /* eslint consistent-return: */
    getMultiSwitchStatus(subItem, formData) {
      const sepArr = formData.field_value.split(',');
      for (let cnt = 0; cnt < sepArr.length; cnt += 1) {
        if (sepArr[cnt] === subItem.internal_value) {
          return true;
        }
      }
    },
    /**
     * add switch on/off effect to product type
     */
    /* eslint no-param-reassign:  */
    setProductType(oValue, nValue) {
      this.errors.remove(this.insuranceType.field_name);
      if (this.insuranceType.multi_select) {
        let valCheck = false;
        const sepArr = this.insuranceType.field_value.split(',');
        for (let cnt = 0; cnt < sepArr.length; cnt += 1) {
          if (sepArr[cnt] === nValue) {
            valCheck = true;
          }
        }
        if (valCheck) {
          if (this.insuranceType.field_value.includes(',')) {
            const existArr = this.insuranceType.field_value.split(',');
            let tempVal = '';
            for (let vCnt = 0; vCnt < existArr.length; vCnt += 1) {
              if (nValue !== existArr[vCnt]) {
                if (tempVal === '') {
                  tempVal += existArr[vCnt];
                } else {
                  tempVal += `,${existArr[vCnt]}`;
                }
              }
            }
            this.insuranceType.field_value = tempVal;
          } else {
            this.insuranceType.field_value = '';
          }
        } else if (this.insuranceType.field_value === '') {
          this.insuranceType.field_value = nValue;
        } else {
          this.insuranceType.field_value = `${this.insuranceType.field_value},${nValue}`;
        }
      } else {
        /* eslint no-lonely-if:  */
        if (oValue === nValue) {
          this.insuranceType.field_value = '';
        } else {
          this.insuranceType.field_value = nValue;
        }
      }
    },
  },
};
</script>
/* eslint-disable */

<style scoped lang="scss">
button .each_product .fa-2x {
  vertical-align: -0.1em;
}
.each_product {
  padding: 4px 0px;
}
.first_product-rad {
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}
label{
    margin-bottom: 0.125rem;
    font-size: 0.75rem;
    font-weight: 600;
}

.ins-type-disp{
  font-size: 0.75rem !important;
  margin-bottom: 0px;
  margin-top: 1px !important;
  margin-left: 3px;
}
/***Product BTNS***/
.switch-box-type{
  line-height: 13px !important;
  font-size: 0.540rem !important;
  text-transform: none !important;
  margin: 0 !important;
  width: 25%;
  font-weight: 600;
  min-width: 60px;
  border-width: 1px;
  border-style: solid;
}
.switch-box-type:focus {
  box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, .45);
  -webkit-box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, .45);
}
  /***Product BTNS-Breakpoints***/
  @media (min-width: 768px) and (max-width: 992px) {
    .btn.switch-box-type{
      width: 50% !important;
    }
  }
  /***Hover***/
  .switch-box-type:hover{
    color: #FFFFFF !important;
  }
  /***Active***/
  .btn.switch-box-type.active{
    color: #FFFFFF !important;
  }


/***Auto BTN***/
.auto-blue-box{
  border-color: $var-color-auto !important;
  color: $var-color-auto !important;
}
  /***Hover***/
  .auto-blue-box:hover{
    background-color:$var-color-auto;
  }
  /***Active***/
  .btn.auto.active{
    background-color:$var-color-auto;
  }
/***Home BTN***/
.home-green-box{
  border-color: $var-color-home !important;
  color: $var-color-home !important;
}
  /***Hover***/
  .home-green-box:hover{
    background-color:$var-color-home !important;
  }
  /***Active***/
  .btn.home.active{
    background-color: $var-color-home;
  }
/***Condo BTN***/
.condo-purple-box{
  border-color: $var-color-condo !important;
  color: $var-color-condo !important;
}
  /***Hover***/
  .condo-purple-box:hover{
    background-color: $var-color-condo !important;
  }
  /***Active***/
  .btn.condo.active{
    background-color: $var-color-condo;
  }
/***Renter BTN***/
.renter-lg-box{
  border-color:$var-color-renter !important;
  color: $var-color-renter !important;
}
  /***Hover***/
  .renter-lg-box:hover{
    background-color: $var-color-renter !important;
  }
  /***Active***/
  .btn.apartment.active{
    background-color:$var-color-renter;
  }

.no-raidus, .btn-group .no-raidus{
  border-top-right-radius: 0rem !important;
  border-bottom-right-radius: 0rem !important;
  border-top-left-radius: 0rem !important;
  border-bottom-left-radius: 0rem !important;
}
.pt-sub-text {
  font-weight: normal;
  color: #545454;
}
.home-auto-bundle{
  width: 100%;
  border-radius: 0.25rem !important;
  margin-top: 10px !important;
}
.home-auto-bundle-lg-box{
  border-color:$var-color-home-auto-bundle !important;
  color: $var-color-home-auto-bundle !important;
}
/***Hover***/
.home-auto-bundle-lg-box:hover{
  background-color: $var-color-home-auto-bundle !important;
  .fa-home-auto-bundle{
    background-color: #FFFFFF;
  }
}
/***Active***/
.btn.home-auto-bundle.active{
  background-color:$var-color-home-auto-bundle;
  .fa-home-auto-bundle {
    background-color: #FFFFFF;
  }
}
/******CONDO+AUTO****/
.condo-auto-bundle{
  width: 100%;
  border-radius: 0.25rem !important;
  margin-top: 10px !important;
}
.condo-auto-bundle-lg-box{
  border-color:$var-color-condo-auto-bundle !important;
  color: $var-color-condo-auto-bundle !important;
}
/***Hover***/
.condo-auto-bundle-lg-box:hover{
  background-color: $var-color-condo-auto-bundle !important;
  .fa-condo-auto-bundle{
    background-color: #FFFFFF;
  }
}
/***Active***/
.btn.condo-auto-bundle.active{
  background-color:$var-color-condo-auto-bundle;
  .fa-condo-auto-bundle {
    background-color: #FFFFFF;
  }
}
/******RENTER+AUTO****/
.renter-auto-bundle{
  width: 100%;
  border-radius: 0.25rem !important;
  margin-top: 10px !important;
}
.renter-auto-bundle-lg-box{
  border-color:$var-color-renter-auto-bundle !important;
  color: $var-color-renter-auto-bundle !important;
}
/***Hover***/
.renter-auto-bundle-lg-box:hover{
  background-color: $var-color-renter-auto-bundle !important;
  .fa-renter-auto-bundle{
    background-color: #FFFFFF;
  }
}
/***Active***/
.btn.renter-auto-bundle.active{
  background-color:$var-color-renter-auto-bundle;
  .fa-renter-auto-bundle {
    background-color: #FFFFFF;
  }
}
.switch-box-type:nth-child(4) {
  border-top-right-radius:0.25rem !important;
  border-bottom-right-radius:0.25rem !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/interactive/InputProductType.vue?c15d3c9e